import axios from 'axios';

// 统一 axios 实例，所有页面用这个，不要直接 import axios
const api = axios.create({
  baseURL: '',
  // AI 对话（GLM 推理模型常态 30~60s）和 PDF 导出（1~2 分钟）都超 30s，
  // 与 nginx proxy_read_timeout 180s 对齐；实测 30s 必挂
  timeout: 180000,
});

// 请求拦截器：自动注入 JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ---------- 全局错误 Snackbar 机制 ----------
// GlobalSnackbar 组件挂载时注册回调，响应拦截器通过此回调通知 UI 层
let _globalErrorCallback = null;

export function registerGlobalErrorHandler(handler) {
  _globalErrorCallback = handler;
}

export function unregisterGlobalErrorHandler() {
  _globalErrorCallback = null;
}

// 响应拦截器：401 自动跳登录，其余错误触发全局 Snackbar
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // token 失效，清空并跳登录
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 避免在登录页反复跳转
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    } else {
      // 非 401 错误：显示全局 Snackbar（排除被取消的请求）
      if (!axios.isCancel(error)) {
        const msg =
          error.response?.data?.error ||
          error.response?.statusText ||
          error.message ||
          '请求失败，请稍后重试';
        if (_globalErrorCallback) {
          _globalErrorCallback(msg);
        }
      }
    }
    return Promise.reject(error);
  }
);

// 登录
export async function login(username, password) {
  const res = await api.post('/api/auth/login', { username, password });
  if (res.data.token) {
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user || { username }));
  }
  return res.data;
}

// 登出
export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/login';
}

// 是否已登录
export function isAuthenticated() {
  return !!localStorage.getItem('token');
}

// 当前用户
export function getCurrentUser() {
  const u = localStorage.getItem('user');
  return u ? JSON.parse(u) : null;
}

export default api;
